import * as React from 'react';
import { useMutation, MutationHookOptions } from '@apollo/react-hooks';

import { message } from 'antd';

import { REPROCESS_SOCIAL_MENTION_MUTATION } from '@frontend/app/queries';
import {
  ReprocessSocialMentionMutation,
  ReprocessSocialMentionMutationVariables,
} from '@frontend/app/queries/types/ReprocessSocialMentionMutation';

const { useEffect } = React;

type IOptions = MutationHookOptions<ReprocessSocialMentionMutation, ReprocessSocialMentionMutationVariables>;
export function useReprocessSocialMention(options: IOptions = {}) {
  const [reprocessSocialMention, { loading, error }] = useMutation<
    ReprocessSocialMentionMutation,
    ReprocessSocialMentionMutationVariables
  >(REPROCESS_SOCIAL_MENTION_MUTATION, options);

  useEffect(() => {
    if (error) {
      message.error(error.message);
    }
  }, [error]);

  return {
    reprocessSocialMention,
    loading,
  };
}
